import { OptionDto } from "@/dtos";
import { RechargerType } from "@/helpers/types";

const rechargerTypes = [
    { value: RechargerType.PHYSICAL, label: 'Físico' },
    { value: RechargerType.VIRTUAL, label: 'Virtual' },
] as OptionDto[];

export const getRechargerTypeOptions = (): OptionDto[] => {
    return rechargerTypes;
}

export const getRechargerTypeOption = (value?: number): OptionDto => {
    return rechargerTypes.find((x) => x.value == value) ?? rechargerTypes[0];
}

export const getRechargerTypeLabel = (value: number): string => {
    return rechargerTypes.find((x) => x.value == value)?.label ?? rechargerTypes[0].label;
}